module.exports = __webpack_public_path__ + "a1ecc3b826d01251edddf29c3e4e1e97.woff";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/fonts/themify.woff?v=1.0.0
// module id = 569
// module chunks = 0